/* eslint-disable camelcase */
import PageActionCreators from 'actions/framework/PageActionCreators';
import sdnApi from 'services/api/sdn';
import addressUtils from 'utils/Address';
import urlUtils from 'utils/Url';
import catalogUtils from 'utils/Catalog';
import ConstructorRecsUtils from 'utils/ConstructorRecs';
import decorators from 'utils/decorators';
import sysUtils from 'utils/ShopYourStore';
import Empty from 'constants/empty';
import { SET_NEW_PRODUCTS_PAGE, SET_BESTSELLER_PRODUCTS_PAGE } from 'constants/actionTypes/storeAggregation';
import { RESULTS_COUNT } from 'constants/constructorConstants';

const { transformConstructorResponseForCarousel } = ConstructorRecsUtils;

class StoreAggregationActionCreators extends PageActionCreators {
    isNewPage = () => true;

    updatePage = () => ({});

    openPage = () => ({});

    setNewProductsPage = payload => {
        return {
            type: SET_NEW_PRODUCTS_PAGE,
            payload
        };
    };

    setBestsellerProductsPage = payload => {
        return {
            type: SET_BESTSELLER_PRODUCTS_PAGE,
            payload
        };
    };

    fetchNewProducts = (podId, currentPage = 1, pageSize = RESULTS_COUNT.CONTENT_PAGE_SIZE, showLoading = false) => {
        return async (dispatch, getState) => {
            try {
                const { user } = getState();
                const storeId = user?.preferredStore;
                const zipCode = addressUtils.formatZipCode(user?.preferredZipCode);
                const ref = urlUtils.getParams()?.ref || [];

                const payload = {
                    podId,
                    storeId,
                    zipCode,
                    currentPage,
                    pageSize,
                    ref
                };

                const contextId = catalogUtils.createContextId();
                const response = !showLoading
                    ? await sdnApi.getNewProducts(payload)
                    : await decorators.withInterstice(sdnApi.getNewProducts)(payload);

                const eligibilityFlags = response?.data?.eligibilityFlags || Empty.Object;
                const constructorData = response?.data?.constructor || Empty.Object;
                const { results } = constructorData?.response;

                if (results) {
                    let items = transformConstructorResponseForCarousel(results);
                    items = sysUtils.mergeElegibilityFlags(items, eligibilityFlags);

                    dispatch(
                        this.setNewProductsPage({
                            contextId,
                            items,
                            currentPage,
                            ...(response?.data || Empty.Object)
                        })
                    );
                }
            } catch (error) {
                Sephora.logger.info('[NEW] Failed to fetch.', error);
            }
        };
    };

    fetchBestsellersProducts = (podId, currentPage = 1, pageSize = RESULTS_COUNT.CONTENT_PAGE_SIZE, showLoading = false) => {
        return async (dispatch, getState) => {
            try {
                const { user } = getState();
                const storeId = user?.preferredStore;
                const zipCode = addressUtils.formatZipCode(user?.preferredZipCode);
                const ref = urlUtils.getParams()?.ref || [];

                const payload = {
                    podId,
                    storeId,
                    zipCode,
                    currentPage,
                    pageSize,
                    ref
                };

                const contextId = catalogUtils.createContextId();
                const response = !showLoading
                    ? await sdnApi.getBestsellersProducts(payload)
                    : await decorators.withInterstice(sdnApi.getBestsellersProducts)(payload);

                const eligibilityFlags = response?.data?.eligibilityFlags || Empty.Object;
                const constructorData = response?.data?.constructor || Empty.Object;
                const { results } = constructorData?.response;

                if (results) {
                    let items = transformConstructorResponseForCarousel(results);
                    items = sysUtils.mergeElegibilityFlags(items, eligibilityFlags);

                    dispatch(
                        this.setBestsellerProductsPage({
                            contextId,
                            items,
                            currentPage,
                            ...(response?.data || Empty.Object)
                        })
                    );
                }
            } catch (error) {
                Sephora.logger.info('[BESTSELLER] Failed to fetch.', error);
            }
        };
    };
}

const StoreAggregationActions = new StoreAggregationActionCreators();

export default StoreAggregationActions;
